import compose from 'vegas-js-core/src/functors/compose'

import withLocale from './withLocale'
import withLang   from './withLang'

const i18n = compose( withLang, withLocale );

export default i18n ;